import React from 'react'
import { Route } from 'react-router-dom'
import NFCE from './nfce/NFCE'
import SwitchRouter from 'components/SwitchRouter'

export default function Routes({ match: { path } }) {
    const routes = [
        { path: `${path}/nfce`, component: NFCE }
    ]
    return (
        <SwitchRouter>
            {routes.map((props, i) => <Route key={i} {...props} />)}
        </SwitchRouter>
    )
}
